export type UserDoubleClickedSymbolFromTableAction = {
    type: 'userDoubleClickedSymbolFromTable';
    symbol: string;
    tabId: string;
};

export const userDoubleClickedSymbolFromTable = (
    tabId: string,
    symbol: string,
): UserDoubleClickedSymbolFromTableAction => ({
    symbol,
    tabId,
    type: 'userDoubleClickedSymbolFromTable',
});

export type ResultsWidgetActions = UserDoubleClickedSymbolFromTableAction;
